<template>
  <OrderPackingDetail label="Susulan Reimbursement" movement-type="follow-up" type="reimbursement" :index-path="indexPath" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail },
  props: {
    indexPath: String
  }
}
</script>